// Returns true on SSR and SPA if page was SSR'd
export const isPageSSRd = (): boolean => {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	return Boolean(process.env.REACT_SSR || window.__SSR_RENDERED__);
};
